module.exports = __webpack_public_path__ + "img/reports-th.a46c148.png";